// Wrap children in a default groupProps object
export const buildGroupProps = (children: NonNullable<React.ReactNode>) => ({
  role: undefined,
  'aria-label': undefined,
  children,
});
